import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import slide_1 from "../../assets/Images/slide-1.jpg";
import slide_2 from "../../assets/Images/slide-2.jpg";
import slide_small_1 from "../../assets/Images/slide-small-1.jpg";
import slide_small_2 from "../../assets/Images/slide-small-2.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function ImageSlider(props) {
    const [isVisible, setIsVisible] = useState(false);
    const [nextImage, setNextImage] = useState(null);
    const [prevImage, setPrevImage] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const { selectedLanguage } = props
    console.log(selectedLanguage, 'data')
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const CustomNextArrow = ({ onClick }) => (
        <div
            className="custom-arrow next"
            onClick={() => { onClick(); setIsVisible(false) }}
            onMouseEnter={() => setNextImage(currentSlide === 0 ? slide_small_2 : slide_small_1)}
            onMouseLeave={() => setNextImage(null)}>
            <FaChevronRight />
            {nextImage && <img src={nextImage} alt="next" className="preview-image next-image" />}
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div
            className="custom-arrow prev"
            onClick={() => { onClick(); setIsVisible(false) }}
            onMouseEnter={() => setPrevImage(currentSlide === 0 ? slide_small_2 : slide_small_1)}
            onMouseLeave={() => setPrevImage(null)}>
            <FaChevronLeft />
            {prevImage && <img src={prevImage} alt="prev" className="preview-image" />}
        </div>
    );
    const handleSlideChange = (current) => {
        setCurrentSlide(current);
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    };
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        afterChange: handleSlideChange
    };
    console.log('visible', isVisible)
    return (
        <div className="slider-container">
            <Slider {...settings}>
                <div className="design-1-img-slider">
                    <img src={slide_1} alt="img" />
                    {isVisible ? <div className="slider-img-text" data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="200"
                        data-aos-duration="1000">
                        <p className="text-1">{selectedLanguage?.txt_treat_your_teeth}</p>
                        <p className="text-2">{selectedLanguage?.txt_visit_egypt}</p>
                    </div> : null}
                </div>
                <div className="design-1-img-slider">
                    <img src={slide_2} alt="img" />
                    {isVisible ?
                        <div className="slider-img-right-text" data-aos="fade-down"
                            data-aos-easing="ease-out-bounce"
                            data-aos-delay="200"
                            data-aos-duration="1000">
                            <p className="text-1">{selectedLanguage?.txt_treat_your_teeth}</p>
                            <div className="img-2-text"><p className="text-2">{selectedLanguage?.txt_visit_egypt}</p></div>
                        </div>
                        : null}
                </div>
            </Slider>
        </div>
    );
}

export default ImageSlider;

